export const SET_LAUNCH_INFO = 'SET_LAUNCH_INFO';

/**
 * Stores the full launch-info response so downstream consumers can
 * read conversionSource and location without a second network call.
 * @param {{ conversionSource: string | null, location: string | null }} payload
 */
export const setLaunchInfo = ({ conversionSource, location }) => ({
	type: SET_LAUNCH_INFO,
	payload: { conversionSource, location },
});
